import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';

import { $detail, $filter } from 'signals/global.signals';
import UniversalInput from 'components/global/UniversalInput';
import { handleFilterChange } from 'components/global/_helpers/global.helpers';
import { Col, Row } from 'react-bootstrap';
import { INVESTOR_TYPE_OPTIONS } from 'components/global/_helpers/global.consts';
import FounderDealPipelineRow from 'components/views/FounderDeal/_components/FounderDealPipelineRow';

const FounderDealPipeline = () => (
  <SimpleCard>
    <Row className="mb-16 pb-0 align-items-center border-bottom border-gray-700">
      <Col md={6}>
        <UniversalInput
          placeholder="Search Investors by name..."
          className="rounded border-0 bg-gray-700 w-100"
          name="search"
          value={$filter.value.investorSearch}
          onChange={(e) => handleFilterChange({ name: 'investorSearch', value: e.target.value })}
        />
      </Col>
      <Col md={3}>
        <UniversalInput
          type="select"
          options={INVESTOR_TYPE_OPTIONS}
          name="investorTypes"
          placeholder="Filter By Investor Type"
          isMulti
          value={INVESTOR_TYPE_OPTIONS.filter((status) => $filter.value.investorTypes?.includes(status.value))}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
            handleFilterChange({ name: 'investorTypes', value: selectedValues });
          }}
        />
      </Col>
    </Row>
    <SignalTable
      headers={[
        { key: 'name', value: 'Name' },
        { key: 'investorType', value: 'Investor Type' },
        { key: 'committed', value: 'Committed' },
        { key: 'invested', value: 'Invested' },
        { key: 'PipelineStatus', value: 'Status' },
        { key: 'Actions', value: 'Actions' },
      ]}
      rows={FounderDealPipelineRow({
        data: $detail.value?.pipelineItems?.filter((pipelineItem) => {
          const search = $filter.value.investorSearch?.trim();
          const types = $filter.value.investorTypes;

          const isInSearchOrSearchIsEmpty = !search || pipelineItem.organization.name?.toLowerCase().includes(search.toLowerCase());
          const isInTypesOrTypesIsEmpty = !types || types.length === 0 || types.includes(pipelineItem.organization.investorType);

          return isInSearchOrSearchIsEmpty && isInTypesOrTypesIsEmpty;
        }) || [],
      })}
    />
  </SimpleCard>
);

export default FounderDealPipeline;
